export default {
    title: "Tehnomax",
    storeOverview: "Store overview",
    welcomeMessage: "Welcome to your store",
    verification: "Your store is currently in the process of verification. Our admin team is going to check your data and you will soon be notified if your store has been successfully verified.",
    afterVerification: "After successful verification, your store will become available to customers.",
    notVerified: "Your store is not verified and it's not visible to buyers. To verify it click ",
    here: "here",
    isVerified: "Store is verified",
    orders: {
        title: "Orders",
        viewLink: "View",
        newOrders: "New orders",
        openOrders: "Open orders",
    },
    statistics: {
        title: "Statistics",
        totalVisits: "Total visits",
        totalPurchases: "Total purchases",
        averageGrade: "Average grade"
    },
    incomeOverview: {
        title: "Income overview",
        totalIncome: "Total Income"
    },
    income: {
        title: "Income",
        date: "Pick a date",
        thisYear: "This year",
        lastMonth: "Last month",
        lastWeek: "Last week",
        lastThreeDays: "Last three days",
        custom: "Custom"
    },
    rolesUsers: {
        title: "Roles and users",
        viewLink: "View",
        online: "Online",
        offline: "Offline"
    },
    ordersByCity: {
        title: "Orders by city"
    },
    popularProducts: {
        title: "Popular products"
    },
    pagination: {
        showing: "Showing",
        outOf: "out of",
        people: "people"
    },
    days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
    },
    months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
    }
}
